import { render } from "./homeManage.vue?vue&type=template&id=8a811442&scoped=true"
import script from "./homeManage.vue?vue&type=script&lang=js"
export * from "./homeManage.vue?vue&type=script&lang=js"

import "./homeManage.vue?vue&type=style&index=0&id=8a811442&lang=less&scoped=true"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a811442"]])

export default __exports__